import { render, staticRenderFns } from "./DepManage.vue?vue&type=template&id=b5434742&"
import script from "./DepManage.vue?vue&type=script&lang=js&"
export * from "./DepManage.vue?vue&type=script&lang=js&"
import style0 from "./DepManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports